import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";

@Component({
  selector: 'app-price-comparison',
  templateUrl: './price-comparison.component.html',
  styleUrls: ['./price-comparison.component.scss']
})
export class PriceComparisonComponent implements OnInit {

  breadcrumbItems: breadcrumbItem[] = [
    {
      label: 'Home',
      active: false,
      url: "/home",
    },
    {
      label: 'AI',
      active: false,
      url: "",
    },
    {
      label: 'Price Comparison',
      active: true,
      url: "",
    }
  ];

    constructor(
    private BreadcrumbService: BreadcrumbService,

    ) {
    this.BreadcrumbService.setValue(this.breadcrumbItems);

     }

  ngOnInit(): void {
  }

}
